<LoginPrompt v-if="!isLoggedIn" />
<ProjectsManager v-else />
